import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Header, Page } from 'components'

import useStyles from './styles'
import { Button, Card, CardContent, Checkbox, Divider, Grid, TextField, Typography } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { useFormState } from 'hooks/useFormState'
import { cutMaxLength } from 'utils/helpers'
import { useOrgaoService } from 'hooks/useOrgaoService'
import { useRegionalService } from 'hooks/useRegionalService'
import { useDivisaoService } from 'hooks/useDivisaoService'
import { useSetorService } from 'hooks/useSetorService'
import { BackButton } from 'components/BackButton/BackButton'
import { Espelho } from 'components/Espelho'
import { useAnuncioService } from 'hooks/useAnuncioService'
import useRouter from 'utils/useRouter'

import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { Editor } from '@tinymce/tinymce-react'
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const schema = {
  titulo: {
    presence: { allowEmpty: false, message: '^Report é obrigatório' },
  },
  destino: {
    presence: { allowEmpty: false, message: '^Descrição é obrigatório' },
  },
  destinoSelecionado: {
    presence: { allowEmpty: false, message: '^Descrição é obrigatório' },
  },
  resumo: {
    presence: { allowEmpty: false, message: '^Descrição é obrigatório' },
  },
  conteudo: {
    presence: { allowEmpty: false, message: '^Descrição é obrigatório' },
  },
}

export const CadastrarAnuncio = (props) => {
  const { route } = props
  const router = useRouter()
  const classes = useStyles()
  const anuncioForm = useFormState(schema, {
    titulo: null,
    destino: null,
    destinoSelecionado: [],
    resumo: null,
    conteudo: null,
  })
  const anuncioService = useAnuncioService()
  const orgaoService = useOrgaoService()
  const regionalService = useRegionalService()
  const divisaoService = useDivisaoService()
  const setorService = useSetorService()
  const [orgao, setOrgao] = useState([])
  const [regional, setRegional] = useState([])
  const [divisao, setDivisao] = useState([])
  const [setores, setSetores] = useState([])
  const [abrirEspelho, setAbrirEspelho] = useState(false)
  const [processandoAnuncio, setProcessandoAnuncio] = useState(false)
  const [isvalid, setIsValid] = useState(true)
  const editorRef = useRef(null)

  const fetchOrgaos = useCallback(async () => {
    const response = await orgaoService.listarOrgaosAsync()
    setOrgao(response)
  }, [])

  useEffect(() => {
    fetchOrgaos()
  }, [fetchOrgaos])

  const fetchSetores = useCallback(async () => {
    const response = await setorService.listarSetoresAsync()
    setSetores(response)
  }, [])

  useEffect(() => {
    fetchSetores()
  }, [fetchSetores])

  const fetchRegionais = useCallback(async () => {
    const response = await regionalService.listarRegionaisAnuncio(setProcessandoAnuncio)
    setRegional(response)
  }, [])

  useEffect(() => {
    fetchRegionais()
  }, [fetchRegionais])

  const fetchDivisao = useCallback(async () => {
    const response = await divisaoService.listarDivisaoAnuncio(setProcessandoAnuncio)
    setDivisao(response)
  }, [])

  useEffect(() => {
    fetchDivisao()
  }, [fetchDivisao])

  const handleOpenEspelho = () => {
    setAbrirEspelho(true)
  }

  const handleConfirmar = async () => {
    await anuncioService.cadastrarAnuncioAsync(anuncioForm.formState.values, setProcessandoAnuncio)
    router.history.push('/dashboard')
  }

  const destino = ['Orgão', 'Regional', 'Divisão', 'Setor']
  const maxLength250 = (newValue) => cutMaxLength(newValue, 250)

  useEffect(() => {
    if (anuncioForm.hasErrorWithoutTouch('titulo') || anuncioForm.hasErrorWithoutTouch('destino') || anuncioForm.hasErrorWithoutTouch('destinoSelecionado') || anuncioForm.hasErrorWithoutTouch('conteudo') || anuncioForm.hasErrorWithoutTouch('resumo')) {
      setIsValid(false)
    } else {
      setIsValid(true)
    }
  }, [anuncioForm])

  const handleValorChange = (e) => {
    anuncioForm.setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        conteudo: e.target.getContent(),
      },
    }))
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Card className={classes.results}>
        <CardContent>
          <Grid className={classes.fieldGroup} alignItems="center" spacing={0} container justifyContent="space-between" md={12} sm={12} xs={12}>
            <Grid container item md={12} sm={12} xs={12} justifyContent="space-between">
              <Grid className={classes.item} item md={6} sm={6} xs={12}>
                <TextField
                  error={anuncioForm.hasError('titulo')}
                  fullWidth
                  helperText={anuncioForm.hasError('titulo') ? anuncioForm.formState.errors.titulo[0] : null}
                  label="TÍTULO"
                  name="titulo"
                  onChange={(e) => anuncioForm.handleChangeWithModification(e, maxLength250)}
                  value={anuncioForm.formState.values.titulo || ''}
                  variant="outlined"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Typography variant="caption">Caracteres restantes: {250 - (anuncioForm.formState.values.titulo?.length ? anuncioForm.formState.values.titulo?.length : 0)}</Typography>
              </Grid>
              <Grid className={classes.item} item md={6} sm={6} xs={12}>
                <AutocompleteNative
                  value={anuncioForm.formState.values.destino || null}
                  name="destino"
                  noOptionsText="Sem informações"
                  options={destino}
                  getOptionSelected={(option, value) => option === value}
                  onChange={(event, newValue) => {
                    anuncioForm.handleChangeNewValueByNameProperty(event, newValue, 'destino')
                  }}
                  getOptionLabel={(option) => `${option}`}
                  renderOption={(option) => `${option}`}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="DESTINO"
                      variant="outlined"
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>

              {anuncioForm.formState.values.destino === 'Orgão' ? (
                <Grid className={classes.item} item md={12} sm={12} xs={12}>
                  <AutocompleteNative
                    value={anuncioForm.formState.values.destinoSelecionado || []}
                    multiple
                    name="destinoSelecionado"
                    noOptionsText="Sem informações"
                    options={orgao}
                    disableCloseOnSelect
                    onChange={(event, newValue) => {
                      anuncioForm.handleChangeNewValueByNameProperty(event, newValue, 'destinoSelecionado')
                    }}
                    getOptionLabel={(option) => `${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()}`}
                    renderOption={(option, { selected }) => (
                      <>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{
                            marginRight: 8,
                          }}
                          checked={selected}
                        />
                        {`${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()}`}
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        required
                        label="DESTINO SELECIONADO"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>
              ) : null}

              {anuncioForm.formState.values.destino === 'Regional' ? (
                <Grid className={classes.item} item md={12} sm={12} xs={12}>
                  <AutocompleteNative
                    value={anuncioForm.formState.values.destinoSelecionado || []}
                    multiple
                    name="destinoSelecionado"
                    noOptionsText="Sem informações"
                    options={regional}
                    disableCloseOnSelect
                    onChange={(event, newValue) => {
                      anuncioForm.handleChangeNewValueByNameProperty(event, newValue, 'destinoSelecionado')
                    }}
                    getOptionLabel={(option) =>
                      `${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()} / 
                      ${option.orgao?.nome?.toUpperCase()} - ${option.orgao?.sigla?.toUpperCase()}`
                    }
                    renderOption={(option, { selected }) => (
                      <>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{
                            marginRight: 8,
                          }}
                          checked={selected}
                        />
                        {`${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()} / 
                          ${option.orgao?.nome?.toUpperCase()} - ${option.orgao?.sigla?.toUpperCase()}`}
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        required
                        label="DESTINO SELECIONADO"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>
              ) : null}

              {anuncioForm.formState.values.destino === 'Divisão' ? (
                <Grid className={classes.item} item md={12} sm={12} xs={12}>
                  <AutocompleteNative
                    value={anuncioForm.formState.values.destinoSelecionado || []}
                    multiple
                    name="destinoSelecionado"
                    noOptionsText="Sem informações"
                    options={divisao}
                    disableCloseOnSelect
                    onChange={(event, newValue) => {
                      anuncioForm.handleChangeNewValueByNameProperty(event, newValue, 'destinoSelecionado')
                    }}
                    getOptionLabel={(option) =>
                      `${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()} / 
                      ${option.regional?.nome?.toUpperCase()} - ${option.regional?.sigla?.toUpperCase()} / 
                      ${option.regional?.orgao?.nome?.toUpperCase()} - ${option.regional?.orgao?.sigla?.toUpperCase()}`
                    }
                    renderOption={(option, { selected }) => (
                      <>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{
                            marginRight: 8,
                          }}
                          checked={selected}
                        />
                        {`${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()} / 
                          ${option.regional?.nome?.toUpperCase()} - ${option.regional?.sigla?.toUpperCase()} / 
                          ${option.regional?.orgao?.nome?.toUpperCase()} - ${option.regional?.orgao?.sigla?.toUpperCase()}`}
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        required
                        label="DESTINO SELECIONADO"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>
              ) : null}

              {anuncioForm.formState.values.destino === 'Setor' ? (
                <Grid className={classes.item} item md={12} sm={12} xs={12}>
                  <AutocompleteNative
                    value={anuncioForm.formState.values.destinoSelecionado || []}
                    multiple
                    name="destinoSelecionado"
                    noOptionsText="Sem informações"
                    options={setores}
                    disableCloseOnSelect
                    onChange={(event, newValue) => {
                      anuncioForm.handleChangeNewValueByNameProperty(event, newValue, 'destinoSelecionado')
                    }}
                    getOptionLabel={(option) =>
                      `${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()} / 
                      ${option.divisao?.nome?.toUpperCase()} - ${option.divisao?.sigla?.toUpperCase()} / 
                      ${option.divisao?.regional?.nome?.toUpperCase()} - ${option.divisao?.regional?.sigla?.toUpperCase()} / 
                      ${option.divisao?.regional?.orgao?.nome?.toUpperCase()} - ${option.divisao?.regional?.orgao?.sigla?.toUpperCase()}`
                    }
                    renderOption={(option, { selected }) => (
                      <>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{
                            marginRight: 8,
                          }}
                          checked={selected}
                        />
                        {`${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()} / 
                          ${option.divisao?.nome?.toUpperCase()} - ${option.divisao?.sigla?.toUpperCase()} / 
                          ${option.divisao?.regional?.nome?.toUpperCase()} - ${option.divisao?.regional?.sigla?.toUpperCase()} / 
                          ${option.divisao?.regional?.orgao?.nome?.toUpperCase()} - ${option.divisao?.regional?.orgao?.sigla?.toUpperCase()}`}
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        required
                        label="DESTINO SELECIONADO"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>
              ) : null}

              <Grid className={classes.item} item md={12} sm={12} xs={12}>
                <TextField
                  error={anuncioForm.hasError('resumo')}
                  fullWidth
                  helperText={anuncioForm.hasError('resumo') ? anuncioForm.formState.errors.resumo[0] : null}
                  label="RESUMO"
                  name="resumo"
                  onChange={anuncioForm.handleChange}
                  value={anuncioForm.formState.values.resumo || ''}
                  minRows={5}
                  multiline
                  variant="outlined"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid className={classes.item} item md={12} sm={12} xs={12}>
                <Editor
                  tinymceScriptSrc="/tinymce/tinymce.min.js"
                  licenseKey="gpl"
                  onInit={(_, editor) => (editorRef.current = editor)}
                  // eslint-disable-next-line no-return-assign
                  initialValue={''}
                  onChange={handleValorChange}
                  init={{
                    style_formats_merge: true,
                    image_caption: true,
                    remove_script_host: false,
                    relative_urls: false,
                    height: 800,
                    pagebreak_separator: '<p style="page-break-after: always;">&nbsp;</p>',
                    menubar: false,
                    language: 'pt_BR',
                    plugins: ['advlist autolink lists link image charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table paste code help wordcount noneditable pagebreak'],
                    toolbar: 'undo redo | formatselect  | table | ' + 'bold italic backcolor | alignleft aligncenter ' + 'alignright alignjustify | bullist numlist | ' + ' | pagebreak',
                    style_formats: [
                      {
                        title: 'Indent',
                        selector: 'p',
                        styles: { 'text-indent': '30px' },
                      },
                    ],
                    content_style: `
                        body { 
                          font-family:Helvetica;
                          Arial,sans-serif; 
                          font-size:14px; 
                       
                        }
                      
                        .image {
                          display: block;
                          width: 100%;
                          margin: auto;
                        }
            
                        img {
                          display: block;
                          margin: auto;
                        }
            
                      
                        .image figcaption {
                            margin: 6px 8px 6px 8px;
                            text-align: center;
                            font-size: 12px;
                        },
                    `,
                  }}
                />

                {/* <TextField
                error={anuncioForm.hasError('conteudo')}
                fullWidth
                helperText={anuncioForm.hasError('conteudo') ? anuncioForm.formState.errors.conteudo[0] : null}
                label="CONTEÚDO"
                name="conteudo"
                onChange={anuncioForm.handleChange}
                value={anuncioForm.formState.values.conteudo || ''}
                minRows={5} 
                multiline
                variant="outlined"
                required
                InputLabelProps={{
                  shrink: true,
                }}
              /> */}
              </Grid>
            </Grid>
          </Grid>

          <Grid container justifyContent="space-between">
            <Grid item>
              <BackButton />
            </Grid>
            <Grid item>
              <Button variant="contained" onClick={handleOpenEspelho} className={classes.botoesFormulario} color="secondary" disabled={!isvalid}>
                Cadastrar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Espelho aberto={abrirEspelho} setAberto={setAbrirEspelho} handleConfirmar={handleConfirmar} processando={processandoAnuncio} titulo="CONFIRMAÇÃO DOS DADOS PREENCHIDOS">
        <Grid item>
          <Typography>
            <b>DADOS GERAIS</b>
          </Typography>
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <Divider className={classes.dividerTitle} />
        </Grid>
        <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho} spacing={1}>
          <Grid item md={6} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>Título</b>
            </Typography>
            <Typography>{anuncioForm?.formState.values.titulo || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>Destino</b>
            </Typography>
            <Typography>{anuncioForm?.formState.values.destino || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>Destino Selecionado</b>
            </Typography>
            <Typography>
              {anuncioForm?.formState.values.destinoSelecionado.map((option, index) => [
                index > 0 && <Divider className={classes.dividerTitle} key={`divider-${index}`} />, // Adiciona um Divider entre os elementos
                anuncioForm?.formState.values.destino === 'Orgão'
                  ? `${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()}`
                  : anuncioForm?.formState.values.destino === 'Regional'
                  ? `${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()} / ${option.orgao?.nome?.toUpperCase()} - ${option.orgao?.sigla?.toUpperCase()}`
                  : anuncioForm?.formState.values.destino === 'Divisão'
                  ? `${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()} / ${option.regional?.nome?.toUpperCase()} - ${option.regional?.sigla?.toUpperCase()} / ${option.regional?.orgao?.nome?.toUpperCase()} - ${option.regional?.orgao?.sigla?.toUpperCase()}`
                  : anuncioForm?.formState.values.destino === 'Setor'
                  ? `${option.nome?.toUpperCase()} - ${option.sigla?.toUpperCase()} / ${option.divisao?.nome?.toUpperCase()} - ${option.divisao?.sigla?.toUpperCase()} / ${option.divisao?.regional?.nome?.toUpperCase()} - ${option.divisao?.regional?.sigla?.toUpperCase()} / ${option.divisao?.regional?.orgao?.nome?.toUpperCase()} - ${option.divisao?.regional?.orgao?.sigla?.toUpperCase()}`
                  : null,
              ])}
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>Resumo</b>
            </Typography>
            <Typography>{anuncioForm?.formState.values.resumo || 'NÃO INFORMADO'}</Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Typography className={classes.dadoEspelho}>
              <b>Conteúdo</b>
            </Typography>
            <Typography>{anuncioForm?.formState.values.conteudo || 'NÃO INFORMADO'}</Typography>
          </Grid>
        </Grid>
      </Espelho>
    </Page>
  )
}
